/* Ayviora verlanglijst - bewaart producten lokaal in de browser, zonder app.
   Sleutel: ayviora_wishlist (array met product-handles). */
(function () {
  var KEY = 'ayviora_wishlist';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* privémodus: stil negeren */
    }
    paint();
    document.dispatchEvent(new CustomEvent('ayviora:wishlist', { detail: { items: list } }));
  }

  function has(handle) {
    return read().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i === -1) list.push(handle);
    else list.splice(i, 1);
    write(list);
    return i === -1;
  }

  function paint() {
    var count = read().length;

    document.querySelectorAll('[data-ay-wish-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });

    document.querySelectorAll('[data-ay-wish]').forEach(function (btn) {
      var on = has(btn.getAttribute('data-ay-wish'));
      btn.classList.toggle('is-saved', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = btn.querySelector('[data-ay-wish-label]');
      if (label) label.textContent = on ? 'Bewaard' : 'Bewaren';
      btn.setAttribute('aria-label', on ? 'Verwijder uit verlanglijst' : 'Bewaar in verlanglijst');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ay-wish]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn.getAttribute('data-ay-wish'));
  });

  window.AyvioraWishlist = { read: read, has: has, toggle: toggle, refresh: paint };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paint);
  } else {
    paint();
  }
})();
